import React from 'react'
import PropTypes from 'prop-types'
import {
  CheckOutFlow,
  OrderProvider,
  ContactProvider,
  GraphProvider,
} from '@rebeldotcom/ui'
import { strings } from '../../content/checkout-payment.strings'

const propTypes = {
  user: PropTypes.object,
}

const defaultProps = {
  user: null,
}

const Order = ({ user }) => {
  return (
    <GraphProvider>
      <ContactProvider>
        <OrderProvider>
          <CheckOutFlow strings={strings} user={user} />
        </OrderProvider>
      </ContactProvider>
    </GraphProvider>
  )
}

Order.propTypes = propTypes
Order.defaultProps = defaultProps
export { Order }
